import { useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import { useServerError } from "../Utils/handleServerError";
import UserService from "../Services/UserService";
import "../CSS/deposit-log.css";

const UserDepositLog = () => {
  const { users, selectedUser } = useSelector((state) => state.usersSlice);
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState([]);

  const { tokens } = useSelector((state) => state.authSlice);

  const [error, setError] = useState(null);

  useServerError(error);

  function openErrorMessage(error) {
    setError(error);

    setTimeout(() => {
      setError(null);
    }, 4000);
  }

  const selectedUserData = useMemo(() => {
    return users.filter((user) => user.user_id === selectedUser)[0] || null;
  }, [selectedUser, users]);

  const fetchUserDeposits = async (user_id) => {
    try {
      setLoading(true);
      const res = await UserService.get_user_deposit_log(tokens, user_id);

      setData(res.data.data);
    } catch (error) {
      openErrorMessage(error);
    }
    setLoading(false);
  };

  useEffect(() => {
    if (selectedUser && tokens) {
      fetchUserDeposits(selectedUser);
    }
  }, [selectedUser, tokens]);

  if (!selectedUser) return null;

  return (
    <div className="main_routes bv-user-deposit-log">
      <h4>
        Deposit Log For {selectedUserData.firstname} {selectedUserData.lastname}
      </h4>

      {loading && <div className="loading">Loading...</div>}

      {!loading && selectedUser && (
        <div className="responsive-table">
          <table>
            <tr>
              <th>S/N</th>
              <th>Transaction ID</th>
              <th>Amount Deposited</th>
              <th>Status</th>
              <th>Date</th>
            </tr>

            {data.map((item, idx) => (
              <tr key={item.deposit_id}>
                <td>{idx + 1}</td>
                <td>{item.deposit_id}</td>
                <td>{item.amount}</td>
                <td>{item.status}</td>
                <td>{new Date(item.createdAt).toISOString().split("T")[0]}</td>
              </tr>
            ))}
          </table>
        </div>
      )}
    </div>
  );
};

export default UserDepositLog;
